"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchHelper = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _apiBusy = require("../api-busy/slice/api-busy.helper");

var _lifecycle = require("../lifecycle/slice/lifecycle.selectors");
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} text A response from a network request
 *
 * @return {object}          The parsed JSON from the request or null if no body
 */


function parseJSON(text) {
  return text ? JSON.parse(text) : null;
}
/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */


function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

function ajaxOK(response) {
  (0, _apiBusy.ajaxEnded)();
  return response;
}

function ajaxKO(reason) {
  (0, _apiBusy.ajaxEnded)();
  return Promise.reject(reason);
}
/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */


function fetchJson(url, options) {
  (0, _apiBusy.ajaxStarts)();
  return fetch(url, options).then(checkStatus).then(function (response) {
    return response.text();
  }).then(parseJSON).then(ajaxOK)["catch"](ajaxKO);
}
/**
 * Requests a URL to a DealerSocket API, returns a promise.
 * The bearer access token is added to the headers.
 */


function fetchApi(url, options) {
  var modifiedOptions = options || {}; // ensure method defaults to 'GET'

  modifiedOptions.method = modifiedOptions.method || 'GET';

  var state = _reduxUtils.storeHelper.getState();

  var token = (0, _lifecycle.accessTokenSelector)(state);

  if (token) {
    var headers = modifiedOptions.headers || new Headers();
    headers.append('Authorization', "Bearer ".concat(token));
    modifiedOptions.headers = headers;
  }

  return fetchJson(url, modifiedOptions);
}

var fetchHelper = {
  fetchApi: fetchApi,
  fetchJson: fetchJson
};
exports.fetchHelper = fetchHelper;